/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ShareTarget {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return ShareTarget.fixupPrototype; }

    static newInstance(model: Partial<ShareTarget>): ShareTarget {
        let obj = Object.assign(new ShareTarget(), model);
        ShareTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ShareTarget>): ShareTarget {
        if (!model) return null;
        return ShareTarget.newInstance(<ShareTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ShareTarget) {
        if (!obj) return;

        models.ShareTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ShareTarget): boolean {
        switch (obj.__type)
        {
            case "ShareTargetForReservation":
                Object.setPrototypeOf(obj, models.ShareTargetForReservation.prototype);
                break;
            case "ShareTargetForSavingsPlan":
                Object.setPrototypeOf(obj, models.ShareTargetForSavingsPlan.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ShareTarget)[] {
        return [
            models.ShareTargetForReservation,
            models.ShareTargetForSavingsPlan,
        ];
    }

    fixupFields() {
        if (this.percentage === undefined) {
            this.percentage = 0;
        }
    }

    /**
     * Target service account ID
     */
    service_account_id: string;

    /**
     * Percentage of unshared benefit to allocate
     */
    percentage: number;

}
